'use client';

import { useEffect } from 'react';
import { jucyAttribution } from '@/lib/jucyAttribution';

export function JucyAttribution() {
    useEffect(() => {
        jucyAttribution.init();
    }, []);
    return null;
}
